'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgStatusIndicator = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ viewBox: "0 0 200 200", ref: ref }, props, { children: jsxRuntime.jsx("path", { fill: "currentColor", d: "             M 100, 100             m -75, 0             a 75,75 0 1,0 150,0             a 75,75 0 1,0 -150,0             " }) }))); };
var ForwardRef = React.forwardRef(SvgStatusIndicator);

exports["default"] = ForwardRef;
//# sourceMappingURL=StatusIndicator.js.map
